import axios from "../helpers/axios";
import { categoryConstants } from "./constants";
import { getProductsBySlug } from "./product.action";

export const getAllCategory = () => {
    return async dispatch => {
        dispatch({ type: categoryConstants.GET_ALL_CATEGORIES_REQUEST });

        const res = await axios.get(`category/getcategory`);

        if (res.status === 200) {
            const { categoryList, categoryDetails } = res.data;

            dispatch({
                type: categoryConstants.GET_ALL_CATEGORIES_SUCCESS,
                payload: { categories: categoryList, categoryDetails }
            });
        } else {
            dispatch({
                type: categoryConstants.GET_ALL_CATEGORIES_FAILURE,
                payload: { error: res.data.error }
            });
        }
    };
};

export const addCategory = (form) => {
    return async dispatch => {
        dispatch({ type: categoryConstants.ADD_NEW_CATEGORY_REQUEST });

        try {
            const res = await axios.post(`/category/create`, form);

            if (res.status === 201) {
                dispatch({
                    type: categoryConstants.ADD_NEW_CATEGORY_SUCCESS,
                    payload: {
                        category: res.data.category,
                        message: res.data.message
                    }
                });
            } else {
                dispatch({
                    type: categoryConstants.ADD_NEW_CATEGORY_FAILURE,
                    payload: {
                        error: res.data.error,
                        message: res.data.message
                    }
                });
            }
        } catch (error) {
            dispatch({
                type: categoryConstants.ADD_NEW_CATEGORY_FAILURE,
                payload: {
                    error: error.response?.data?.error || error.message,
                    message: error.response?.data?.message || 'Ошибка при создании категории'
                }
            });
        }
    };
};

export const updateCategories = (form) => {
    return async dispatch => {
        dispatch({ type: categoryConstants.UPDATE_CATEGORIES_REQUEST });

        try {
            const res = await axios.post(`/category/update`, form);

            if (res.status === 201) {
                dispatch({
                    type: categoryConstants.UPDATE_CATEGORIES_SUCCESS,
                    payload: {
                        message: res.data.message
                    }
                });

                dispatch(getAllCategory());
            } else {
                const { error, message } = res.data;

                dispatch({
                    type: categoryConstants.UPDATE_CATEGORIES_FAILURE,
                    payload: { error, message }
                });
            }
        } catch (error) {
            dispatch({
                type: categoryConstants.UPDATE_CATEGORIES_FAILURE,
                payload: {
                    error: error.response?.data?.error || error.message,
                    message: error.response?.data?.message || 'Ошибка при обновлении категорий'
                }
            });
        }
    };
};

export const updateCategorySurfaceEditorById = (id, enabled) => {
    return async dispatch => {
        dispatch({ type: categoryConstants.UPDATE_CATEGORIES_REQUEST });

        try {
            const res = await axios.patch(`/category/${id}/surface-editor`, {
                surfaceEditorEnabled: enabled
            });

            if (res.status === 200) {
                dispatch({
                    type: categoryConstants.UPDATE_CATEGORIES_SUCCESS,
                    payload: {
                        message: res.data.message
                    }
                });

                dispatch(getAllCategory());

                return res.data.category;
            }

            dispatch({
                type: categoryConstants.UPDATE_CATEGORIES_FAILURE,
                payload: {
                    error: res.data.error,
                    message: res.data.message
                }
            });

            return null;
        } catch (error) {
            dispatch({
                type: categoryConstants.UPDATE_CATEGORIES_FAILURE,
                payload: {
                    error: error.response?.data?.error || error.message,
                    message: error.response?.data?.message || 'Ошибка при изменении редактора поверхности'
                }
            });

            return null;
        }
    };
};

export const deleteCategories = (ids) => {
    return async dispatch => {
        dispatch({ type: categoryConstants.DELETE_CATEGORIES_REQUEST });

        try {
            const res = await axios.post(`/category/delete`, {
                payload: {
                    ids
                }
            });

            if (res.status == 201) {
                dispatch(getAllCategory());

                dispatch({
                    type: categoryConstants.DELETE_CATEGORIES_SUCCESS,
                    payload: { message: res.data.message }
                });

                return true;
            }

            const { error } = res.data;

            dispatch({
                type: categoryConstants.DELETE_CATEGORIES_FAILURE,
                payload: { error, message: res.data.message }
            });

            return false;
        } catch (error) {
            dispatch({
                type: categoryConstants.DELETE_CATEGORIES_FAILURE,
                payload: {
                    error: error.response?.data?.error || error.message,
                    message: error.response?.data?.message || 'Ошибка при удалении категории'
                }
            });

            return false;
        }
    };
};

export const getCategoryDetailsById = (category) => {
    return async dispatch => {
        try {
            const res = await axios.get(`/category/${category._id}`);
            localStorage.setItem('TEST', JSON.stringify(category));

            dispatch({
                type: categoryConstants.GET_CATEGORY_DETAILS_BY_ID_SUCCESS,
                payload: { categoryDetails: res.data.category }
            });
        } catch (error) {
            console.log(error);
        }
    };
};

export const updateCategoryVisiblePriceById = (id, slug) => async (dispatch) => {
    try {
        const data = await axios.get(`/category/priceVisible/${id}`);

        dispatch({
            type: categoryConstants.UPDATE_CATEGORY_VISIBLE_PRICE_BY_ID_SUCCESS,
            payload: data
        });

        dispatch(getAllCategory());

        if (slug !== "all") {
            dispatch(getProductsBySlug(slug));
        }
    } catch (error) {
        console.log(error);
    }
};

export const updateCategoryVisibleById = (id) => async (dispatch) => {
    try {
        dispatch({ type: categoryConstants.UPDATE_CATEGORY_VISIBLE_BY_ID_REQUEST });

        const res = await axios.get(`/category/visibleCategory/${id}`);

        if (res.status === 200) {
            dispatch({
                type: categoryConstants.UPDATE_CATEGORY_VISIBLE_BY_ID_SUCCESS,
                payload: res.data
            });
        } else {
            dispatch({
                type: categoryConstants.UPDATE_CATEGORY_VISIBLE_BY_ID_FAILURE,
                payload: res.data
            });
        }

        dispatch(getAllCategory());
    } catch (error) {
        console.log(error);
    }
};